import type { PlayerDto } from './player.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { tokenManager } from '../token-manager';
import { PlayerDtoSchema } from './player.schema';

export const playerApi = {

  async getMePlayerProfile() {
    const decoded = tokenManager.decodeJWT();
    if (!decoded?.sub) {
      throw new Error('User ID not found');
    }

    const response = await httpClient.get<PlayerDto>(
      ENDPOINTS.gamification.players.playerProfile(decoded.sub),
    );

    return validateWithZod(PlayerDtoSchema, response);
  },

};
